<template>
  <v-dialog v-model="dialog" persistent max-width="850px">
    <v-card>
      <v-card-title class="mx-3">
        <span class="headline">{{ $t("Wave.actions.receive") }}</span>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>
            {{ $t("$vuetify.close") }}
          </span>
        </v-tooltip>
      </v-card-title>
      <v-card-text>
        <v-snackbar
          v-model="snackbar"
          color="error"
          timeout="6000"
          text
          top
          absolute
        >
          {{ $t("StockContainers.selectContainer.unselect") }}
          <template v-slot:action="{ attrs }">
            <v-icon
              dark
              class="mx-2"
              v-bind="attrs"
              color="error"
              @click="snackbar = false"
              >fa-times
            </v-icon>
          </template>
        </v-snackbar>
        <v-container>
          <v-row dense align="center">
            <v-col cols="12" sm="5" md="4">
              <SearcherContainerCategory v-model="containerCategorySelected" />
            </v-col>
            <v-col cols="9" sm="5" md="7">
              <SearcherKeyword
                getFocus
                :label="$t('StockContainers.Keyword')"
                v-model="searcherContainerKeyword"
                @text="containersKeyword = $event"
              />
            </v-col>
            <v-col cols="3" sm="2" md="1">
              <v-tooltip>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="containers"
            :options.sync="options"
            :loading="loading"
            multi-sort
            disable-pagination
            hide-default-footer
            class="elevation-0 px-6"
            fixed-header
            height="360px"
          >
            <template v-slot:top v-if="containerIdsSelected.length">
              <v-card-text>
                <v-subheader>{{
                  $t("StockContainers.selectContainer.selectedContainers")
                }}</v-subheader>

                <v-chip-group v-model="containerBarCodesSelected">
                  <v-chip
                    v-for="container in containerBarCodesSelected"
                    :key="container"
                    close
                    small
                    @click:close="del(container)"
                  >
                    {{ container }}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                small
                text
                :color="
                  containerIdsSelected.includes(item.id) ? 'accent' : 'info'
                "
                @click.stop="
                  containerIdsSelected.includes(item.id)
                    ? containerIdsSelected.splice(
                        containerIdsSelected.indexOf(item.id),
                        1
                      )
                    : (addContainers = item)
                "
              >
                {{
                  containerIdsSelected.includes(item.id)
                    ? $t("StockContainers.selectContainer.selected")
                    : $t("StockContainers.selectContainer.select")
                }}
              </v-btn>
            </template>
          </v-data-table>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined @click="dialog = false">{{
          $t("$vuetify.close")
        }}</v-btn>
        <v-btn color="accent" @click="receiveWave()">
          （{{
            $t("StockContainers.selectContainer.currentSelected", [
              containerIdsSelected.length,
            ])
          }}）{{ $t("StockContainers.selectContainer.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import Containers from "@/api/containers";
import Waves from "@/api/waves";
import SearcherContainerCategory from "@/components/plugins/SearcherContainerCategory";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";

const defaultOptions = {
  stock_id: "",
  status: 0,
  container_category_code: "",
};

export default {
  name: "ContainerDialog",

  props: {
    value: Boolean,
    label: String,
    wave: Object,
    cancelMode: Boolean,
  },

  components: {
    SearcherContainerCategory,
    SearcherKeyword,
  },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("StockContainers.Fields.container_categories"),
          align: "start",
          sortable: false,
          value: "container_category_name",
        },
        {
          text: i18n.t("StockContainers.Fields.container_name"),
          align: "start",
          sortable: false,
          value: "container_name",
        },
        {
          text: i18n.t("StockContainers.Fields.container_name"),
          align: "start",
          sortable: false,
          value: "container_code",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "center",
          sortable: false,
          value: "actions",
        },
      ];
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    snackbar: false,
    containers: [],
    options: JSON.parse(JSON.stringify(defaultOptions)),
    containerCategorySelected: {},
    searcherContainerKeyword: "",
    containersKeyword: "",
    addContainers: null,
    containerIdsSelected: [],
    containerBarCodesSelected: [],
  }),

  methods: {
    del(container) {
      this.containerBarCodesSelected.splice(
        this.containerBarCodesSelected.indexOf(container.bar_code),
        1
      );
      this.containerIdsSelected.splice(
        this.containerIdsSelected.indexOf(container.id),
        1
      );
    },
    onSearch() {
      Containers.fetch(
        Object.assign(this.options, {
          keyword: this.containersKeyword,
        })
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.containers = response.data.containers;
            if (this.containers.length == 1) {
              this.addContainers = this.containers[0];
            }
          }
        }.bind(this)
      );
    },
    getContainersFromAPI() {
      var options = JSON.parse(JSON.stringify(this.options));
      Containers.fetch(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.containers = response.data.containers;
          }
        }.bind(this)
      );
    },
    //领取波次
    receiveWave() {
      if (!this.containerIdsSelected.length) {
        this.snackbar = true;
      } else {
        Waves.receive({
          wave_id: this.wave.id,
          stock_id: this.wave.stock_id,
          container_ids: this.containerIdsSelected,
        }).then(
          function (response) {
            response;
            if (response.data.status.isOK()) {
              this.$emit("save", this.wave);
              this.dialog = false;
            }
          }.bind(this)
        );
      }
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = true;
          this.getContainersFromAPI();
        }
      },
    },
    wave: {
      immediate: true, //初始赋值调用
      handler() {
        this.options.stock_id = this.wave ? this.wave.stock_id : "";
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) {
          this.$emit("close");
        } else {
          this.options = JSON.parse(
            JSON.stringify(
              Object.assign({}, defaultOptions, {
                stock_id: this.wave.stock_id,
              })
            )
          );
          this.containerIdsSelected = [];
          this.containerBarCodesSelected = [];
          this.addContainers = null;
        }
      },
    },
    options: {
      deep: true,
      handler() {
        this.getContainersFromAPI();
      },
    },
    searcherContainerKeyword: {
      handler() {
        this.containersKeyword = this.searcherContainerKeyword;
        this.onSearch();
      },
    },
    containerCategorySelected: {
      handler() {
        this.options.container_category_code = this.containerCategorySelected
          ? this.containerCategorySelected.category_code
          : "";
      },
    },
    addContainers: {
      handler() {
        if (this.addContainers && this.addContainers.id) {
          if (!this.$store.state.settings.wave_container_multiple) {
            //波次领取容器设置的单选
            if (this.containerIdsSelected.length)
              this.containerIdsSelected = [];
            if (this.containerBarCodesSelected.length)
              this.containerBarCodesSelected = [];
            this.containerIdsSelected.push(this.addContainers.id);
            this.containerBarCodesSelected.push(this.addContainers.bar_code);
            //自动提交
            if (Object.keys(this.addContainers).length) {
              this.receiveWave();
            }
          } else {
            //波次领取容器设置为多选
            this.containerIdsSelected.push(this.addContainers.id);
            this.containerBarCodesSelected.push(this.addContainers.bar_code);
          }
        }
      },
    },
    containerIdsSelected: {
      handler() {
        this.addContainers = null;
      },
    },
  },
};
</script>